import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/viec-lam/[id]/client.tsx");
